import React, { useState } from 'react';
import { PROJECTS, Cluster } from '../../data/portfolio';
import ProjectMark from './ProjectMark';

const FILTERS: Array<'all' | Cluster> = [
  'all',
  'llm agents',
  'nlp research',
  'applied ml',
  'systems',
];

interface ProjectsProps {
  onOpen: (id: string) => void;
}

function shortLinkLabel(label: string): string {
  const l = label.toLowerCase();
  if (l.includes('live') || l.includes('demo') || l.includes('chrome') || l.includes('site')) {
    return 'live demo';
  }
  if (l.includes('source') || l.includes('github')) {
    return 'github';
  }
  return label;
}

const Projects: React.FC<ProjectsProps> = ({ onOpen }) => {
  const [filter, setFilter] = useState<'all' | Cluster>('all');

  const rows = PROJECTS.filter((p) => filter === 'all' || p.cluster === filter).sort(
    (a, b) => b.year - a.year
  );

  return (
    <div className="page">
      <header>
        <h2>
          projects <span>{PROJECTS.length} builds</span>
        </h2>
        <p>Selected builds: open a row for architecture & metrics, or jump straight to a link.</p>
      </header>
      <div className="filters">
        {FILTERS.map((f) => (
          <button
            key={f}
            type="button"
            data-f={f}
            aria-pressed={filter === f}
            onClick={() => setFilter(f)}
          >
            {f}
          </button>
        ))}
      </div>
      <div className="worklist">
        {rows.map((p) => (
          <div key={p.id} className="workrow">
            <button type="button" className="workrow-main" onClick={() => onOpen(p.id)}>
              <span className="wyear">{p.year}</span>
              <span className="wmain">
                <ProjectMark name={p.name} id={p.id} logo={p.logo} size="sm" />
                <span>
                  <span className="wname">{p.name}</span>
                  <span className="wsum">{p.summary}</span>
                </span>
              </span>
            </button>
            <span className="wright">
              <span className="wtags">{p.tags.slice(0, 3).join(' · ')}</span>
              {p.links.length > 0 && (
                <span className="wlinks">
                  {p.links.map(([label, href]) => (
                    <a
                      key={label}
                      className="wlink"
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {shortLinkLabel(label)} ↗
                    </a>
                  ))}
                </span>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
